import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useListCommentsForContractTaskQuery } from "../../../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../../../common/auth/useLoggedInWithOrgContextState";
import { ListLoadError } from "../../../../../../common/ListLoadError";
import { AddComment } from "./AddComment";
import { Comment } from "./Comment";

interface Props {
  taskId: string;
}

export const Comments: React.FC<Props> = ({ taskId }) => {
  const authState = useLoggedInWithOrgContextState();
  const { data, isError, isFetching, refetch } = useListCommentsForContractTaskQuery({
    organizationId: authState.selectedOrg.id,
    taskId: taskId,
  });
  const { t } = useTranslation();
  if (isError) {
    return <ListLoadError message={t("Could not load comments.")} onRetry={() => refetch()} isRetrying={isFetching} />;
  }
  if (!data) {
    return <div>{t("Loading")}...</div>;
  }
  return (
    <Flex flexDirection={"column"}>
      {data.canComment && <AddComment taskId={taskId} onComplete={refetch} />}
      {data.comments.length === 0 && (
        <Text fontStyle={"italic"} mt="10px">
          {t("No comments yet")}
        </Text>
      )}
      {data.comments.map((comment) => (
        <Comment key={comment.id} comment={comment} onChangeComplete={refetch} />
      ))}
    </Flex>
  );
};
